import { render, staticRenderFns } from "./GerenciarPerfilCard.vue?vue&type=template&id=35bd3c8b&scoped=true"
import script from "./GerenciarPerfilCard.vue?vue&type=script&lang=js"
export * from "./GerenciarPerfilCard.vue?vue&type=script&lang=js"
import style0 from "./GerenciarPerfilCard.vue?vue&type=style&index=0&id=35bd3c8b&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bd3c8b",
  null
  
)

export default component.exports